import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Sparkles, RefreshCw } from 'lucide-react';
import { axios, auth, mbUrl, errMsg, rm, muted, primary, card } from './mbApi';
import { SuggestionCard } from './SuggestionCard';

const Spend = ({ f }) => {
  if (!f.currencies.some((x) => x !== 'MYR')) return rm(f.amount_spent_myr);
  if (!f.currencies.includes('MYR')) return 'Bukan MYR';
  return <>{rm(f.amount_spent_myr)} <span className="text-amber-400">(MYR sahaja)</span></>;
};

const FamilyRow = ({ f }) => (
  <tr className="border-t border-[hsl(var(--border))] align-top" data-testid={`mb-angle-row-${f.angle_tag || 'untagged'}`}>
    <td className={`py-1.5 pr-2 ${primary}`}>{f.angle_tag || <span className="text-amber-400">Belum ditag</span>}</td>
    <td className="py-1.5 pr-2">{f.versions}</td>
    <td className="py-1.5 pr-2">{f.ads}</td>
    <td className="py-1.5 pr-2" data-testid={`mb-angle-spend-${f.angle_tag || 'untagged'}`}><Spend f={f} /></td>
    <td className="py-1.5 pr-2">{f.joins_first} <span className="opacity-70">(+{f.joins_rejoin} rejoin)</span></td>
    <td className="py-1.5 pr-2">{rm(f.cps_first_myr)}</td>
    <td className="py-1.5 text-amber-400">{f.warnings.join(' · ')}</td>
  </tr>
);

export const AnalystOverview = ({ ibId, canBrief }) => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const load = useCallback(async () => {
    setErr('');
    try { setD((await axios.get(mbUrl(ibId, '/analyst/overview'), auth())).data); } catch (e) { setErr(errMsg(e, 'Gagal load panel analisis')); }
  }, [ibId]);
  useEffect(() => { load(); }, [load]);
  if (err) {
    return (
      <div className={`${card} text-sm text-red-400 space-y-2`} data-testid="mb-analyst-overview-error">
        <p>{err}</p>
        <Button variant="outline" className="h-10" onClick={load} data-testid="mb-analyst-overview-retry"><RefreshCw size={14} className="mr-1.5" /> Cuba lagi</Button>
      </div>
    );
  }
  if (!d) return <div className={`${card} h-28 animate-pulse`} data-testid="mb-analyst-overview-loading" />;
  return (
    <div className={`${card} space-y-3`} data-testid="mb-analyst-overview">
      <p className={`text-base font-semibold ${primary} flex items-center gap-2`}><Sparkles size={16} className="text-[#F77F00]" /> AI Creative Analyst — corak ikut keluarga angle</p>
      <p className={`text-xs ${muted}`}>
        Jumlah spend & join dikira backend (bukan purata CPS). Baseline RM{d.cfg.baseline_min_myr}–RM{d.cfg.baseline_max_myr} ikut CPS unik. Data {d.source.meta}/{d.source.telegram}.
        Client close: N/A. Corak bukan bukti punca — cadangan dibuat pada setiap versi (tab Pembelajaran dalam butiran task). Membaca kad tidak memanggil AI.
      </p>
      <div className="overflow-x-auto" aria-label="Jadual keluarga angle — leret mendatar jika perlu">
        <table className={`w-full text-xs ${muted} min-w-[640px]`} data-testid="mb-angle-table">
          <thead><tr className="text-left"><th className="pb-1">Tag angle</th><th>Versi</th><th>Iklan</th><th>Spend</th><th>Join unik</th><th>CPS unik</th><th>Amaran</th></tr></thead>
          <tbody>{d.families.map((f) => <FamilyRow key={f.angle_tag || 'untagged'} f={f} />)}</tbody>
        </table>
      </div>
      <p className={`text-sm font-semibold ${primary}`}>Cadangan terkini ({d.suggestions.length})</p>
      {d.suggestions.length === 0 && <p className={`text-sm ${muted}`} data-testid="mb-analyst-no-sugg">Belum ada cadangan. Buka satu task → tab Pembelajaran → &quot;Analisis &amp; Cadang Variasi&quot;.</p>}
      <div className="space-y-2">{d.suggestions.slice(0, 10).map((s) => <SuggestionCard key={s.id} ibId={ibId} s={s} canBrief={canBrief} reload={load} />)}</div>
    </div>
  );
};
